export const MAX_DESCRIPTION_LEN = 300;
export const MAX_DURATION_MINUTES = 7 * 24 * 60;
export const MAX_PRICE = 1000000;
